// Define the validation schema with custom messages
import * as Yup from 'yup';

export const formValidationSchemaTraining = Yup.object().shape({
  selectedAssembly: Yup.object().nullable().required('Assembly is required to enable the Train Model button'),
  selectedDryGasSealTags: Yup.array()
    .min(1, 'Dry Gas Seal Tags are required to enable the Train Model button')
    .max(5, 'You cannot select more than 6 Dry Gas Seal Tags')
});


export const formValidationSchemaModels = Yup.object().shape({
  selectedAssembly: Yup.object().nullable().required('Assembly is required'),
   selectedDryGasSealTags:Yup.object().nullable().required('Dry Gas Seal Tags is required')
});